// baseBody can be used when we want the body regular of 16px on mobile
const baseBody = {
  color: 'text',
  fontFamily: 'body',
  fontSize: 3,
  lineHeight: 2,
  fontWeight: 0,
};

const baseBodyImportant = {
  color: 'text',
  fontFamily: 'body',
  fontSize: 3,
  lineHeight: 2,
  fontWeight: 1,
};

const baseBodyWarning = {
  color: 'supplementary.1',
  fontFamily: 'body',
  fontSize: 3,
  lineHeight: 2,
  fontWeight: 'bold',
};

const baseBodyUnderlined = {
  color: 'text',
  fontFamily: 'body',
  fontSize: 3,
  lineHeight: 2,
  fontWeight: 0,
  textDecorationLine: 'underline',
};

const bodyRegular = {
  maxWidth: 'none',
  color: 'text',
  fontFamily: 'body',
  fontSize: [2, 3],
  lineHeight: 2,
  fontWeight: 0,
};

const bodyRegularDisabled = {
  maxWidth: 'none',
  color: 'disabled',
  fontFamily: 'body',
  fontSize: [2, 3],
  lineHeight: 2,
  fontWeight: 0,
};

const bodyRegularToCaption = {
  maxWidth: 'none',
  color: 'text',
  fontFamily: 'body',
  fontSize: [1, 3],
  lineHeight: 2,
  fontWeight: 0,
};

const buttonAddText = {
  lineHeight: '21px',
  paddingLeft: 1,
  fontFamily: '"Segoe UI", sans-serif',
  fontSize: '14px',
};

const buttonRemoveText = {
  lineHeight: ['21px', '24px'],
  paddingLeft: 1,
  fontFamily: '"Segoe UI", sans-serif',
  fontSize: ['14px', '16px'],
};

const bodyImportant = {
  ...bodyRegular,
  fontWeight: 1,
};

const bodyImportantLight = {
  ...bodyRegular,
  color: 'white',
  fontWeight: 1,
};

const bodyLight = {
  ...bodyRegular,
  color: 'white',
};

const captionImportant = {
  ...bodyRegular,
  fontSize: 1,
  fontWeight: 1,
};

const captionLight = {
  ...bodyRegular,
  color: 'white',
  fontSize: 1,
};

const captionRegular = {
  ...bodyRegular,
  fontSize: 1,
};

const captionImportantSmall = {
  ...bodyRegular,
  fontSize: 0,
  fontWeight: 1,
};

const captionLightSmall = {
  ...bodyRegular,
  color: 'white',
  fontSize: 0,
};

const captionRegularSmall = {
  ...bodyRegular,
  fontSize: 0,
};

const captionRegularSmallInfo = {
  ...bodyRegular,
  marginTop: 3,
  fontSize: 2,
  color: 'info',
};

const footnoteAdditionalInfo = {
  ...bodyRegular,
  color: 'additionalInfo',
  fontSize: 2,
};

const footnoteError = {
  ...bodyRegular,
  color: 'error',
  fontSize: 2,
};

const footnoteGrey = {
  ...bodyRegular,
  color: 'second.0',
  fontSize: 2,
};

const footnoteInput = {
  ...bodyRegular,
  color: 'info',
  fontSize: 2,
};

const footnoteImportant = {
  ...bodyRegular,
  fontSize: 2,
  fontWeight: 1,
};

const footnoteLight = {
  ...bodyRegular,
  color: 'white',
  fontSize: 2,
};

const footnoteRegular = {
  ...bodyRegular,
  fontSize: 2,
};

const footnoteRegularLight = {
  ...bodyRegular,
  color: 'second.0',
  fontSize: 2,
};

const footnoteRegularToCaption = {
  ...bodyRegular,
  fontSize: [1, 2],
};

const footnoteRegularToCaptionSmall = {
  ...bodyRegular,
  fontSize: [0, 2],
};

const footnoteToCaptionSmallDisabledLight = {
  ...bodyRegular,
  fontSize: [0, 2],
  color: 'disabledLight',
};

const footnoteToCaptionSmallImportant = {
  ...bodyRegular,
  fontSize: [0, 2],
  fontWeight: 1,
};

const headlineImportant = {
  ...bodyRegular,
  fontSize: [3, 4],
  fontWeight: 1,
};

const headlineLight = {
  ...bodyRegular,
  color: 'white',
  fontSize: [3, 4],
};

const headlineRegular = {
  ...bodyRegular,
  fontSize: [3, 4],
};

const warningSmall = {
  bg: 'supplementary.1',
  color: 'dark.1',
  fontFamily: 'body',
  fontSize: 0,
  fontWeight: 1,
};

const secondaryCaptionBold = {
  color: 'second.0',
  fontFamily: 'body',
  fontSize: 0,
  fontWeight: 1,
};

const ellipsed: any = {
  ...footnoteRegular,
  display: 'inline-block',
  maxWidth: '300px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const uspParagraph = {
  pt: 1,
};
const coverageCardFractionPrice = {
  ...bodyRegular,
  fontSize: [0, 1],
  fontWeight: 1,
};

const coverageCardWholePrice = {
  ...bodyRegular,
  fontSize: [3, 5],
  fontWeight: 1,
};

const searchOption = {
  ...bodyRegular,
  cursor: 'pointer',
  lineHeight: 3,
  padding: '0 10px',
  '&:hover': {
    bg: 'disabledLight',
  },
};

const bodyV2 = {
  fontFamily: 'body',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
};

const regularV2 = {
  fontFamily: 'body',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 400,
};

const paragraphVariants = {
  baseBody,
  baseBodyImportant,
  baseBodyUnderlined,
  bodyImportant,
  bodyImportantLight,
  bodyLight,
  bodyRegular,
  bodyRegularDisabled,
  bodyRegularToCaption,
  buttonAddText,
  buttonRemoveText,
  captionImportant,
  captionLight,
  captionRegular,
  captionImportantSmall,
  captionLightSmall,
  captionRegularSmall,
  captionRegularSmallInfo,
  footnoteAdditionalInfo,
  footnoteError,
  footnoteGrey,
  footnoteInput,
  footnoteImportant,
  footnoteLight,
  footnoteRegular,
  footnoteRegularLight,
  footnoteRegularToCaption,
  footnoteRegularToCaptionSmall,
  headlineImportant,
  headlineLight,
  headlineRegular,
  warningSmall,
  ellipsed,
  uspParagraph,
  coverageCardFractionPrice,
  coverageCardWholePrice,
  footnoteToCaptionSmallDisabledLight,
  footnoteToCaptionSmallImportant,
  secondaryCaptionBold,
  searchOption,
  baseBodyWarning,
  bodyV2,
  regularV2,
};

export default paragraphVariants;
